// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"MyContentsSettings_btnTextStyle_3fj_n","headingText":"MyContentsSettings_headingText_33ZJi"};